import {SubjectModel} from './models';

export class SubjectChangedItselfEvent {
	subject: SubjectModel;
}
